import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { editSupplyBillItem } from '../../../../../store/supplyBillSlice'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { editSupplyBillItemNameInBillAPI } from '../../../../../api/supply/supplyBillItemAPI'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import NameFieldMain from '../../../../form/fields/NameFieldMain'

const ChangeNameInBillForm = ({ supplyBillItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        supplyBillItemBd ? 
            {
                nameInBill: supplyBillItemBd.nameInBill,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editSupplyBillItemNameInBillAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editSupplyBillItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: supplyBillItemBd.id,
            nameInBill: data.nameInBill,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('nameInBill', 'supplyBillItem') ?
				<NameFieldMain
					required={formDataProductRequiredField('nameInBill', 'supplyBillItem')}
					setValidate={e => updateValidate(setValid, 'nameInBill', e)}
					setValueForm={e => setValueForm(setData, 'nameInBill', e)}
					forciblyValue={data && data.nameInBill ? data.nameInBill : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeNameInBillForm